<div class="eiq-counter">
  <button
    mat-icon-button
    class="eiq-counter__button"
    [disabled]="value() < 1"
    [attr.data-testid]="testId() ? testId() + '-counter-minus' : null"
    (click)="setCount.emit(value() - 1)"
  >
    <fa-icon [icon]="faMinus"></fa-icon>
  </button>
  <span class="eiq-counter__value text__sm fw__600"> {{ value() }} </span>
  <button
    mat-icon-button
    class="eiq-counter__button"
    [disabled]="maxValue() && value() >= maxValue()"
    [attr.data-testid]="testId() ? testId() + '-counter-plus' : null"
    (click)="setCount.emit(value() + 1)"
  >
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</div>
